export function getWishlistApiHeaders({ wcs, ubertoken }) {
  const headers = { };
  const wcsUrlConfig = typeof window === 'undefined' ? wcs.internal : wcs.external

  if (wcsUrlConfig.clientId) headers['X-IBM-Client-Id'] = wcsUrlConfig.clientId;
  if (ubertoken) headers['X-Ubertoken'] = ubertoken;

  return headers
}
